module.exports = "images/enfants_11.dcf96a7a.png";